module.exports = __webpack_public_path__ + "static/media/logo.af87c143.png";